<template>
  <div class="algorithm-annotation-list">
    <b-loading :is-full-page="false" class="small" :active="loading" />
    <template v-if="state.error">
      <b-message type="is-danger" has-icon icon-size="is-small">
        {{ $t('failed-to-load-annotations') }}
      </b-message>
    </template>
    <template v-else-if="!state.items.length && !loading">
      <em class="algorithm-annotations-empty">{{ $t('no-annotation') }}</em>
    </template>
    <div v-else class="algorithm-annotation-previews">
      <annotation-preview
        v-for="annot in state.items"
        :key="annot.id"
        class="algorithm-annotation-preview"
        :annot="annot"
        :size="72"
        :color="color"
        :terms="terms"
        :images="images"
        :show-image-info="false"
        :same-view-on-click="true"
        @updateTermsOrTracks="$emit('updateTermsOrTracks', annot)"
        @centerView="$emit('centerView', { annot, sameView: true })"
        @deletion="$emit('deletion', annot)"
        @select="$emit('select', $event)"
      />
    </div>
    <button
      v-if="state.hasMore"
      class="button is-small is-dark algorithm-load-more"
      :disabled="loading"
      @click="$emit('loadMore')"
    >
      {{ $t('button-load-more') }}
    </button>
  </div>
</template>

<script>
import AnnotationPreview from '@/components/annotations/AnnotationPreview';

export default {
  name: 'algorithm-annotation-list',
  components: {
    AnnotationPreview
  },
  props: {
    state: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    },
    terms: {
      type: Array,
      default: () => []
    },
    images: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../assets/styles/dark-variables';

.algorithm-annotation-list {
  position: relative;
  min-height: 3rem;
  padding: 0.65rem 0.8rem;
}

.algorithm-annotation-previews {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.algorithm-annotation-preview {
  margin: 0;
}

.algorithm-load-more {
  margin-top: 0.65rem;
}

.algorithm-annotations-empty {
  color: $dark-text-secondary;
  font-size: 0.84rem;
}
</style>
